// JavaScript Document
//components/signs/option/Table.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
//import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  table: {
   // minWidth: 650,
	maxHeight:'calc(100vh - 84px)',
	//maxHeight: '100%'
  },
});


export default function SummaryTable(props) {
	const classes = useStyles();
	const {items} = props;
	
	

  return (
    <TableContainer component={Paper} className={classes.table}>
      <Table>
        <TableBody>
          {items.map((row, i) => (
            <TableRow hover role="checkbox" key={i}>
              	<TableCell component="th" scope="row">
                	{row.name}
              	</TableCell>
				<TableCell>{row.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
